module.exports = __webpack_public_path__ + "static/media/footerImage.4a106e49.svg";